import { render, staticRenderFns } from "./ParseResume.vue?vue&type=template&id=55b6d5ee&scoped=true&"
import script from "./ParseResume.vue?vue&type=script&lang=js&"
export * from "./ParseResume.vue?vue&type=script&lang=js&"
import style0 from "./ParseResume.vue?vue&type=style&index=0&id=55b6d5ee&lang=scss&scoped=true&"
import style1 from "./ParseResume.vue?vue&type=style&index=1&id=55b6d5ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b6d5ee",
  null
  
)

export default component.exports